<div class="mb-1.5 flex flex-col gap-1">
  <label [for]="id()" class="mb-1 text-sm font-semibold text-gray-800">
    {{ label() }}
    @if (optional()) {
      <span
        class="ml-1 rounded-sm bg-gray-100 px-1.5 py-0.5 text-xs font-light whitespace-nowrap text-gray-700">
        optional
      </span>
    }
  </label>

  <div class="relative">
    <button
      [id]="id()"
      type="button"
      [disabled]="disabled()"
      [attr.aria-expanded]="isOpened()"
      (click)="toggleMenu()"
      class="flex w-full items-center justify-between rounded-lg border px-3 py-2 text-left text-sm outline-none"
      [ngClass]="triggerClass()">
      <span class="flex min-w-0 items-center gap-2">
        @if (selectedCount() > 0) {
          <span class="rounded-full bg-sky-100 px-2 py-0.5 text-xs text-sky-900">
            {{ selectedCountLabel() }}
          </span>
        } @else {
          <span class="truncate text-gray-500">{{ placeholder() }}</span>
        }
      </span>

      <svg
        aria-hidden="true"
        class="ml-3 size-4 shrink-0 text-gray-400 transition-transform"
        [ngClass]="{ 'rotate-180': isOpened() }">
        <use href="@dashboard-web-order/icons/chevron-down.svg#chevron-down"></use>
      </svg>
    </button>

    @if (isOpened()) {
      <div
        class="absolute top-full right-0 left-0 z-50 mt-1 max-h-72 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg">
        <div class="border-b border-gray-200 p-2">
          <input
            [id]="id() + '-search'"
            type="search"
            [formControl]="searchControl"
            placeholder="Suche"
            (click)="$event.stopPropagation()"
            class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm outline-none focus:border-green-800 focus:ring-1 focus:ring-green-800" />
        </div>

        <div class="max-h-56 overflow-y-auto py-1">
          @for (option of filteredOptions(); track option.value) {
            <button
              type="button"
              role="option"
              [attr.aria-selected]="isSelected(option)"
              (click)="toggleOption(option, $event)"
              class="flex w-full items-center gap-3 px-3 py-2 text-left text-sm transition hover:bg-sky-50 hover:text-sky-900 focus:bg-sky-50 focus:text-sky-900 focus:outline-none">
              <span
                class="flex size-4 shrink-0 items-center justify-center rounded-sm border"
                [ngClass]="
                  isSelected(option)
                    ? 'border-green-800 bg-green-800 text-white'
                    : 'border-gray-300 bg-white'
                ">
                @if (isSelected(option)) {
                  <svg aria-hidden="true" class="size-3">
                    <use href="@dashboard-web-order/icons/check.svg#check"></use>
                  </svg>
                }
              </span>
              <span class="min-w-0 truncate">{{ option.label }}</span>
            </button>
          } @empty {
            <p class="px-3 py-3 text-sm text-gray-500">Keine Ergebnisse gefunden</p>
          }
        </div>
      </div>
    }
  </div>

  <span class="min-h-4 text-xs" [ngClass]="showInvalid() ? 'text-red-500' : 'text-gray-500'">
    @if (showInvalid()) {
      {{ errorText() }}
    } @else {
      {{ hintText() }}
    }
  </span>
</div>
